import React, { useState } from 'react';
import { FiPlus, FiList, FiEdit, FiLink } from 'react-icons/fi';

import ListQuestionAnswers from './ListQuestionAnswers';
import AssociateAnswer from './AssociateAnswer';
import QuestionFlowForm from './QuestionFlowForm';
const Categories: React.FC = () => {
  const [activeView, setActiveView] = useState('list');
  
  return (
    <div>
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-800">Gestione delle Associazioni</h2>
        
        {/* Sous-navigation */}
        <div className="mt-4 flex gap-2">
          <button
            onClick={() => setActiveView('list')}
            className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2
              ${activeView === 'list' 
                ? 'bg-indigo-500 text-white' 
                : 'bg-white text-gray-600 hover:bg-gray-50'
              }`}
          >
            <FiList />
            Lista
          </button>
          {/* <button
            onClick={() => setActiveView('add')}
            className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2
              ${activeView === 'add' 
                ? 'bg-indigo-500 text-white' 
                : 'bg-white text-gray-600 hover:bg-gray-50'
              }`}
          >
            <FiPlus />
            Aggiungere
          </button> */}
          <button
            onClick={() => setActiveView('associate')}
            className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2
              ${activeView === 'associate' 
                ? 'bg-indigo-500 text-white' 
                : 'bg-white text-gray-600 hover:bg-gray-50'
              }`}
          >
            <FiLink />
            Associa
          </button>
          <button
                      onClick={() => setActiveView('flux')}
                      className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2
                        ${activeView === 'flux' 
                          ? 'bg-indigo-500 text-white' 
                          : 'bg-white text-gray-600 hover:bg-gray-50'
                        }`}
                    >
                      <FiLink />
                      Flusso
           </button>
          
        </div>
      </div>

      {/* Contenu */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        {activeView === 'list' && <ListQuestionAnswers />}
        {activeView === 'add' && <AssociateAnswer />}
        {activeView === 'associate' && <AssociateAnswer />}
        {activeView === 'flux' && <QuestionFlowForm />}
      </div>
    </div>
  );
};

export default Categories; 